import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rightChevron",
  "use": "rightChevron-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"rightChevron\"><path d=\"M0 0h24v24H0z\" fill=\"none\" /><path data-name=\"↳color\" d=\"M9.998 7.999l4 4-4 4\" stroke=\"#031425\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" fill=\"none\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol